import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Message } from 'primeng/api';
import { MessageService } from 'primeng/api';

import { FAZILService, Errors, UserService } from '../core';

import { Md5 } from "md5-typescript";
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { UIService } from '../core/services/ui.service';


@Component({
    selector: 'app-login',
    templateUrl: './app.login.component.html',
    styles: ['a { background:#D32F2F;color:#ffffff;font-size:15px;padding:8px 12px;border-radius:3px;-moz-border-radius:3px;-webkit-border-radius:3px;text-decoration:none; }']
})
export class AppLoginComponent {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Errors = { errors: {} };
    msgs: Message[] = [];

    authType: String = 'login';
    title: String = '';
    isSubmitting = false;
    authForm: FormGroup;

    username: String = '';
    password: String = null;
    typePassword: String = 'password';
    
    alertarActualizacion:boolean = false;
    serverVersionNumber:number = NaN;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private uiService: UIService,
        private userService: UserService,
        private messageService: MessageService,
        private fazilService: FAZILService,
        private fb: FormBuilder
    ) {
        
        this.loadAppData();
    }
    
    async loadAppData(){
        const version = await this.uiService.getPlatformVersion();
        this.serverVersionNumber = version.serverVersion;
        this.alertarActualizacion = version.actualizar;
    }

    submitForm() {
        this.messageService.clear(); //Borrar mensajes anteriores
        this.isSubmitting = true;
        this.errors = { errors: {} };

        //Encriptar contraseña
        //this.authForm.value['password'] = Md5.init(this.authForm.value['password']);
        if (this.password == null || this.password == ''){
            this.messageService.add({ severity: 'error', summary: "Error", detail: `¡La contraseña esta vacia!` });
            this.isSubmitting = false;
            return;
        }
        
        var passwordMd5 = Md5.init(this.password);
//        const passwordMd5 = '1243083cb817c922750d5c76fe9d6187'; //jlgranda81@gmail.com
//        const passwordMd5 = '9b7cdfbb8197e92d7ce2e98202153728'; //tecnopro
        const credentials = {
            "username": this.username,
            "password": passwordMd5
        };

        //Encriptar contraseña
        //var encrypted = CryptoJS.AES.encrypt(this.password, environment.credential_app);
        //        const credentials = {
        //            "username": this.username,
        //            "password": encrypted.toString()
        //        };

        this.userService
            .attemptAuth(this.authType, credentials)
            .subscribe(
                data => {
                    this.router.navigateByUrl('')
                },
                err => {
                    if (err["error"]) {
                        this.errors = err["error"];
                        if (this.errors['error'] && this.errors['error'] === 'invalid_grant' || this.errors['error'] === 'unauthorized') {
                            this.messageService.add({ severity: 'error', summary: 'Nombre usuario y contraseña no válidos', detail: `Verifique los datos ingresados e intente nuevamente.` });
                        } else {
                            this.messageService.add({ severity: 'error', summary: this.errors['type'], detail: `${this.errors['message']}` });
                        }
                        this.isSubmitting = false;
                    } else {
                        this.messageService.add({ severity: 'error', summary: "Error", detail: `Se ha producido un error interno. Verique las credenciales y conexión de acceso e intente nuevamente.` });
                        this.isSubmitting = false;
                    }
                }
            );
    }

    irARegistrar(e: any) {
        this.fazilService.irARegistrar();
    }

    irAConfirmarCambiarContrasenia(e: any) {
        this.fazilService.irACambiarContrasenia();
    }
    
    verContrasenia(e: any) {
        if (this.typePassword == 'password') {
            this.typePassword = 'text';
        }
        else {
            this.typePassword = 'password';
        }
    }
    
    actualizarVersion(versionNumber:number){

        this.fazilService.setClienteVersionNumber(versionNumber);
        this.alertarActualizacion = false;
        //Recargar con un parámetro de versión para evitar que el navegador/proxy
        //sirva el index.html desde caché (location.reload() no siempre lo garantiza)
        window.location.href = window.location.pathname + '?v=' + versionNumber;
    }
}
